import React from 'react';
import { Container, Grid, Paper, Typography, Skeleton } from '@mui/material';

import Sidebar from '../Sidebar/Sidebar';
import useAuth from '../../hooks/useAuth';
import { useTranslation } from 'react-i18next';

import PIIValidationUploadPanel from './PIIValidationUploadPanel/PIIValidationUploadPanel';
import PIIValidationAsyncJobsList from './PIIValidationUploadPanel/PIIValidationAsyncJobsList'; 

const PIIValidatorPage = () => {
  const { isLoggedIn, user, isLoading } = useAuth();
  const { t } = useTranslation();

  const renderSkeleton = () => (
    <>
      <Sidebar user={user} />
      <Container maxWidth="xl">
        <Paper 
          elevation={0} 
          sx={{ 
            p: { xs: 2, md: 4 }, 
            mt: 4, 
            borderRadius: 3, 
            border: '1px solid', 
            borderColor: 'divider', 
            bgcolor: 'background.paper' 
          }}
        >
          <Skeleton variant="text" width={260} height={50} />
          <Skeleton variant="text" width={420} height={32} sx={{ mb: 3 }} />
          
          <Grid container spacing={4}>
            <Grid item xs={12} lg={7}>
              <Skeleton variant="rectangular" height={400} sx={{ borderRadius: 2 }} />
            </Grid>
            <Grid item xs={12} lg={5}>
              <Skeleton variant="rectangular" height={400} sx={{ borderRadius: 2 }} />
            </Grid>
          </Grid>
        </Paper>
      </Container>
    </>
  );

  if (!isLoggedIn || isLoading) return renderSkeleton();

  return (
    <>
      <Sidebar user={user} />

      <Container maxWidth="xl">
        <Paper 
          elevation={0} 
          sx={{ 
            p: { xs: 2, md: 4 }, 
            mt: 4, 
            mb: 5, 
            borderRadius: 3, 
            border: '1px solid', 
            borderColor: 'divider', 
            bgcolor: 'background.paper' 
          }}
        >
          <Grid container spacing={4}>
            {/* Header Section */}
            <Grid item xs={12}>
              <Typography variant="h4" sx={{ fontWeight: 700, color: 'text.primary', mb: 1 }}>
                {t('PIIValidatorPage.title', 'Kontrola citlivých údajov (GDPR, NIS, Vyhradené)')}
              </Typography>

              <Typography variant="subtitle1" color="text.secondary">
                {t(
                  'PIIValidatorPage.subtitle',
                  'Nahrajte dokument a zistite, či obsahuje citlivé údaje. Dokument s nájdenými údajmi neodporúčame zdieľať.'
                )}
              </Typography>
            </Grid>

            {/* Upload Panel */}
            <Grid item xs={12} lg={7}>
              <PIIValidationUploadPanel />
            </Grid>

            {/* Async Jobs List */}
            <Grid item xs={12} lg={5}>
              <PIIValidationAsyncJobsList />
            </Grid>
          </Grid>
        </Paper>
      </Container>
    </>
  );
};

export default PIIValidatorPage;